import { render, staticRenderFns } from "./MusicCollectionDetail.vue?vue&type=template&id=2cb84b20"
import script from "./MusicCollectionDetail.vue?vue&type=script&lang=js"
export * from "./MusicCollectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports